import { z } from 'zod';

export const AdminExamLocationRequestListFilterFormSchema = z.object({
  province: z
    .object({
      label: z.string(),
      value: z.string(),
    })
    .optional(),
  examCenters: z.array(
    z.object({
      label: z.string(),
      value: z.string(),
    }),
  ),
});

export type AdminExamLocationRequestListFilterFormInput = z.infer<
  typeof AdminExamLocationRequestListFilterFormSchema
>;
